import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { TourBackdropComponent } from "../tour-backdrop/tour-backdrop.component";

@Component({
  selector: "app-tour-overlay",
  standalone: true,
  imports: [CommonModule, TourBackdropComponent],
  template: `
    <app-tour-backdrop [targetRect]="targetRect"></app-tour-backdrop>
  `,
  styles: [
    `
      :host {
        position: fixed;
        inset: 0;
        z-index: 1000;
        pointer-events: auto;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourOverlayComponent {
  @Input() targetRect?: DOMRect | null;
}
